module.exports = __webpack_public_path__ + "img/Agence_Nationale_de_la_Recherche.9c8147cd.svg";